var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81503 3.18427C1.81503 1.42807 3.2439 0 4.99995 0C6.75544 0 8.18356 1.42889 8.18356 3.18427V4.36795H9.29114C9.66591 4.36795 9.97158 4.67323 9.97158 5.04851V11.3194C9.97158 11.6946 9.66591 12 9.29114 12H0.708757C0.332656 12 0.0283203 11.6946 0.0283203 11.3194V5.04851C0.0283203 4.6732 0.332656 4.36795 0.708757 4.36795H1.81503V3.18427ZM6.76404 4.36795V3.18427C6.76404 2.21189 5.97237 1.41977 4.99995 1.41977C4.02699 1.41977 3.23452 2.21109 3.23452 3.18427V4.36795H6.76404ZM4.31708 10.5286C4.31715 10.5287 4.31719 10.5287 4.31724 10.5288C4.31755 10.5288 4.31787 10.5288 4.3182 10.5288L5.68149 10.5288L5.68151 10.5287V10.5287V8.48754L5.8568 8.35221C6.20033 8.08704 6.40182 7.67616 6.40182 7.24195C6.40182 6.46894 5.7732 5.83915 4.99995 5.83915C4.22687 5.83915 3.59677 6.46877 3.59677 7.24195C3.59677 7.67599 3.79948 8.0872 4.14228 8.35261L4.31705 8.48794L4.31708 10.5286Z",
    fill: "#7A5A54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLock);
export default __webpack_public_path__ + "static/media/ico-lock.b11d6a912fc77f08c10497997af45edb.svg";
export { ForwardRef as ReactComponent };